import axios from 'axios';
import HttpInterface from './HttpInterface';
import { Router } from 'vue-router';

export default class AxiosAdapter implements HttpInterface {
  constructor(router: Router) {
    axios.interceptors.request.use(
      config => {
        const token = localStorage.getItem('token');
        if (token && config.headers) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
      },
      (error): any => {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          localStorage.removeItem('token');
          router.push({ name: 'login' });
        }
        return Promise.reject(error);
      }
    );
  }

  async request(url: string, data: any, method: string): Promise<any> {
    const params = method == 'get' ? data : {};
    const response = await axios({ url, data, method, params });
    return response.data;
  }
}
